
import {useNativeStore} from "@/console-new/stores/native.store";

const replacements = {
	"£": "GBP",
	"$": "USD",
	"€": "EUR",
	"@": "A",
	"à": "a",
	"ä": "a",
	"è": "e",
	"é": "e",
	"ë": "e",
	"ì": "i",
	"ï": "i",
	"ò": "o",
	"ö": "o",
	"ù": "u",
	"ü": "u",
	"À": "A",
	"Ä": "A",
	"È": "E",
	"É": "E",
	"Ë": "E",
	"Ì": "I",
	"Ï": "I",
	"Ò": "O",
	"Ö": "O",
	"Ù": "U",
	"Ü": "U",
	"°": "o",
	"§": "S",
	"¥": "Y",
	"¢": "c",
	"ß": "ss",
	"æ": "ae",
	"œ": "oe"
};

export default class EscPos {

	static init() {
		if (!!EscPos.instance) {
			return EscPos.instance;
		}
		EscPos.instance = new EscPos();
		return EscPos.instance;
	}

	columns() {
		return useNativeStore().isPrintBig ? 48 : 32;
	}

	bold(text) {
		return "\x1b\x45\x0f" + text + "\x1b\x45\x00";
	}

	justifyCenter(text) {
		return "\x1b\x61\x01" + text + "\n\x1b\x61\x00";
	}

	doubleSize(text) {
		return "\x1d\x21\x11" + text + "\x1d\x21\x00";
	}

	tripleSize(text) {
		return "\x1d\x21\x22" + text + "\x1d\x21\x00";
	}

	replaceUnprintableChars(text) {
		const pattern = new RegExp(Object.keys(replacements).map((key) => {
			return key.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
		}).join("|"), "g");

		return text.replace(pattern, (match) => {
			return replacements[match] || match;
		}).replaceAll(/[^\x20-\x7E]/g, "");
	}

	separator() {
		return "-".repeat(this.columns());
	}

	spaceBetween(left, right, doubleHeight = false, isBold = false) {
		let lineLength = this.columns();
		if (doubleHeight) {
			lineLength /= 2;
		}
		let halfLineLen = lineLength / 2;
		let maxLeftLen = halfLineLen;
		if (right.length < maxLeftLen) {
			maxLeftLen = lineLength - right.length - 3;
		}
		let maxRightLen = halfLineLen;
		if (left.length < maxRightLen) {
			maxRightLen = lineLength - left.length - 3;
		}
		if (left.length > maxLeftLen) {
			left = left.substring(0, maxLeftLen) + "..";
		}
		if (right.length > maxRightLen) {
			right = right.substring(0, maxRightLen) + "..";
		}
		let spaceBetweenStrings = lineLength - left.length - right.length;
		if (spaceBetweenStrings < 0) {
			spaceBetweenStrings = 0;
		}
		let stringToPrint = left + " ".repeat(spaceBetweenStrings) + right;
		if(isBold) {
			stringToPrint = this.bold(stringToPrint);
		}
		return doubleHeight ? this.doubleSize(stringToPrint)+"\n" : stringToPrint+"\n";
	}

	fixedRight(left, right, doubleHeight = false, isBold = false) {

		let lineLength = this.columns();
		if (doubleHeight) {
			lineLength = Math.floor(lineLength / 2);
		}

		let rightLen = right.length + 1;
		let leftLen = lineLength - rightLen;
		if (rightLen > lineLength) {
			rightLen = lineLength - 1;
			leftLen = 1;
		}

		let leftWhitespacesCount = 0;
		for (let i = 0; i < left.length; i++) {
			if (left[i] === ' ') {
				leftWhitespacesCount++;
			} else {
				break;
			}
		}
		if (leftWhitespacesCount > 0) {
			leftWhitespacesCount += 2;
		}

		let leftParts = [];
		let lCopy = left;
		let firstPart = true;
		if (!(lCopy.length > leftLen - leftWhitespacesCount && lCopy.length <= leftLen)) {
			while (lCopy.length > leftLen - leftWhitespacesCount) {
				let prefix = '';
				if (!firstPart) {
					prefix = ' '.repeat(leftWhitespacesCount);
				}
				firstPart = false;
				leftParts.push(prefix + lCopy.substring(0, leftLen - prefix.length));
				lCopy = lCopy.substring(leftLen - prefix.length);
			}
		}
		let prefix = '';
		if (!firstPart) {
			prefix = ' '.repeat(leftWhitespacesCount);
		}
		leftParts.push(prefix + lCopy + ' '.repeat(leftLen - prefix.length - lCopy.length));

		let result = "";
		for (let i = 0; i < leftParts.length; i++) {
			let leftPart = leftParts[i];
			let rightPart = ' '.repeat(rightLen);
			if (i === leftParts.length - 1) {
				rightPart = ' ' + right;
			}
			let stringToPrint = leftPart + rightPart;
			if(isBold) {
				stringToPrint = this.bold(leftPart) + this.bold(rightPart);
			}
			stringToPrint = doubleHeight ? this.doubleSize(stringToPrint) : stringToPrint;
			result += stringToPrint + "\n";
		}

		return result;
	}
}
